// extracted by mini-css-extract-plugin
module.exports = {"StarRating":"starRating_StarRating__e6Twv","star":"starRating_star__2IIKN","empty":"starRating_empty__NfhQ0","fill":"starRating_fill__Iklbs","button":"starRating_button__KLr2q"};